import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Center,
  Button,
} from '@chakra-ui/react';

// Home plate SVG icon
const HomePlateIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="white"
    {...props}
  >
    <polygon points="3,3 21,3 21,14 12,21 3,14" />
  </svg>
);

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      minH="100vh"
      w="100%"
      position="absolute"
      top="0"
      left="0"
      bgGradient="linear(to-b, black, #002e0b)"
      color="white"
      fontFamily="'Exo 2', sans-serif"
    >
      <Container maxW="md" pt={32}>
        <Center minH="60vh">
          <VStack gap={8} width="full" textAlign="center">
            <Heading
              as="h1"
              size="2xl"
              fontFamily="Audiowide"
              fontWeight="bold"
              color="white"
            >
              Foul Ball!
            </Heading>
            <Text fontSize="xl" color="whiteAlpha.800">
              You've tried to go to a page out in left field.
            </Text>
            <Text color="whiteAlpha.600">
              That's a 404 scoring error
            </Text>
            <Button
              variant="dominus"
              w="fit-content"
              fontSize="xl"
              px={8}
              py={4}
              leftIcon={<HomePlateIcon />}
              onClick={() => {
                const token = localStorage.getItem('token');
                navigate(token ? '/dashboard' : '/');
              }}
            >
              Head for Home
            </Button>
          </VStack>
        </Center>
      </Container>
    </Box>
  );
};

export default NotFoundPage; 